import { Pipe, PipeTransform } from "@angular/core";
import { isObservable, of } from "rxjs";
import { map, startWith, catchError } from "rxjs/operators";

@Pipe({
  name: "filterDataAsyncLoading",
  standalone: true,
})
export class FilterDataAsyncLoadingPipe implements PipeTransform {
  transform(val) {
    return isObservable(val)
      ? val.pipe(
          map((value: any) => {
            // if value has loading indicator then return false so that skeleton will be displayed.
            // if value is null or undefined return default value to display the filter.
            return value && value.loading ? false : value || [];
          }),
          catchError((error) => {
            console.log(error);
            return of([]);
          })
        )
      : val;
  }
}
